import storage from '../utils/storage';

function hasPermission(permission = '') {
    var permissions = storage().get('permissions');
    permissions = permissions ? permissions : [];
    return permissions.includes(permission);
}

export default hasPermission